import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { TrophyIcon } from 'lucide-react';
import { useProgress, Certificate } from '../hooks/useProgress';
import { CertificateCard } from './CertificateCard';
import { CertificateDetailModal } from './CertificateDetailModal';
export function CertificatesSection() {
  const {
    getAllCertificates
  } = useProgress();
  const certificates = getAllCertificates();
  const earnedCount = certificates.filter(c => c.isEarned).length;
  const [selectedCertificate, setSelectedCertificate] = useState<Certificate | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCertificateClick = (certificate: Certificate) => {
    setSelectedCertificate(certificate);
    setIsModalOpen(true);
  };
  return <div className="mb-8" data-id="element-589">
      <div className="flex items-center justify-between mb-6" data-id="element-590">
        <div className="flex items-center space-x-3" data-id="element-591">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-md" data-id="element-592">
            <TrophyIcon className="w-6 h-6 text-white" data-id="element-593" />
          </div>
          <div data-id="element-594">
            <h2 className="text-xl sm:text-2xl font-bold text-[#132C53]" data-id="element-595">
              Certificate Obținute
            </h2>
            <p className="text-sm text-gray-600" data-id="element-596">
              Diplome oficiale pentru cursurile absolvite
            </p>
          </div>
        </div>
        <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full font-bold text-sm" data-id="element-597">
          {earnedCount} / {certificates.length}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-598">
        {certificates.map((certificate, index) => <motion.div key={certificate.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1
      }} data-id="element-599">
            <CertificateCard certificate={certificate} onClick={() => handleCertificateClick(certificate)} data-id="element-600" />
          </motion.div>)}
      </div>

      <CertificateDetailModal certificate={selectedCertificate} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-601" />
    </div>;
}